module.exports = __webpack_public_path__ + "static/media/icon_send-message-disabled.0fe23ba9.svg";